var map = {
	"./icon_perk_common.png": 292,
	"./icon_perk_epic.png": 4947,
	"./icon_perk_extra_perk_01.png": 5981,
	"./icon_perk_extra_perk_02.png": 1030,
	"./icon_perk_extra_perk_03.png": 247,
	"./icon_perk_legendary.png": 9589,
	"./icon_perk_mask.png": 4418,
	"./icon_perk_rare.png": 7052,
	"./icon_perk_tier_2.png": 8649,
	"./icon_perk_tier_3.png": 9472,
	"./icon_perk_uncommon.png": 7013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8970;